import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/FreightQuotation/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__description')}>
          <h2 className={cn('about__heading')}>
            What is a Freight Quotation?
          </h2>
          <p className={cn('about__paragraph')}>
            A freight quote shows what you'll pay for a shipment, or sometimes a whole stretch of them. It
            lists the loading port, discharge port, how it's shipping, rough transit time, and exactly where
            the money breaks down: base freight, add-ons, local charges. The key part is the fine print on
            terms like how long it's good for and what happens if rates jump which covers the forwarder
            against surprises.
          </p>
          <div className={cn('about__buttons')}>
            <a
              className={cn('about__button-download-word')}
              href="/download/Resources/FreightTemplates/freight_quotation.doc"
              target='_blank'
            >
              Download (Word)
            </a>
            <a
              className={cn('about__button-download-pdf')}
              href="/download/Resources/FreightTemplates/freight_quotation.pdf"
              target='_blank'
            >
              Download (pdf)
            </a>
          </div>
        </div>

        {/* TODO: uncomment when picture is provided */}
        {/* <div className={cn('about__image-container')}>
          <picture>
            <source
              srcSet="/images/pages/Resources/FreightTemplates/BillOfLading/template@2x.webp 2x, 
                      /images/pages/Resources/FreightTemplates/BillOfLading/template.webp 1x"
              sizes="100vw"
            />
            <img
              className={cn('about__image')}
              src="/images/pages/Resources/FreightTemplates/BillOfLading/template.webp"
              alt="template"
            />
          </picture>
        </div> */}

      </div>
    </section>
  );
};

export default SectionAbout;